import { render, staticRenderFns } from "./imageViewer.vue?vue&type=template&id=4b5ac96a&scoped=true"
import script from "./imageViewer.vue?vue&type=script&lang=js"
export * from "./imageViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5ac96a",
  null
  
)

export default component.exports